import { useQuery } from '@tanstack/react-query';
import { fetchBooking } from 'flux/clients/bookings';

export const useBooking = (bookingId: string) => {
  const query = useQuery({
    queryKey: ['booking', bookingId],
    queryFn: () => fetchBooking(bookingId),
  });

  return query;
};
